export { default, derivePageType } from './autoPageView.component';
